import { Modal } from 'antd'
import { isFunction } from 'lodash'

import { loadScript } from '../utils'

import { CaptchaInstance, InitAliyunCaptchaOption } from './interface'

const SDK_SRC =
  'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js'

export const setupCaptcha = async () => {
  window.AliyunCaptchaConfig = {
    // 必填，验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
    region: 'cn',
    // 必填，身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
    prefix: 'g59oo4'
  }
  await loadScript(SDK_SRC)
}

export const initCaptcha = async ({
  getInstance,
  onError,
  ...restOption
}: InitAliyunCaptchaOption) => {
  return new Promise<CaptchaInstance>((resolve, reject) => {
    if (!isFunction(window.initAliyunCaptcha)) {
      Modal.warning({
        title: '提示',
        content: '人机验证程序加载异常，请刷新页面或稍后重试'
      })
      reject(new Error('人机验证程序加载异常，请刷新页面或稍后重试'))
      return
    }
    window.initAliyunCaptcha({
      ...restOption,
      getInstance(instance) {
        getInstance?.(instance)
        resolve(instance)
      },
      onError(error) {
        // 日志上报
        console.error(error)
        onError?.(error)
        reject(error)
      }
    })
  })
}
